import { Controller } from '@hotwired/stimulus'
import Swiper, { Navigation, Pagination } from 'swiper/core'

Swiper.use([Navigation, Pagination])

// 元職員Q&Aカードのカルーセル（reviews_and_experiences/mobile と同じSwiper構成）。
// スワイプ直後の誤クリックはSwiperデフォルトの preventClicks / preventClicksPropagation が
// 抑止するため、カード送り操作とカードタップ（遷移・GA4発火）は自動的に区別される。
// NOTE: 両者は非対称で、遷移抑止（preventDefault）は allowClick === false なら常に効くが、
//       GTMへの伝播抑止（stopPropagation）は swiper.animating が true のときのみ。
//       両端でのバウンス等でスワイプが空振りすると遷移せずGA4だけ飛び得るため、
//       「両端でスワイプを空振りさせてイベントが飛ばないか」は手動QAで確認する。
export default class extends Controller {
  static targets = ['cardList', 'nextButton', 'prevButton', 'pagination']

  get className () {
    return this.element.dataset.classname
  }

  connect () {
    // カード1枚の施設では矢印・ドットがサーバーサイドで出力されないため、
    // Swiperの初期化自体をスキップする（カード1枚の固定表示）。
    // cardListは常時出力され、矢印・ドットの3ターゲット（nextButton / prevButton /
    // pagination）はカルーセル時のみ同時に出力される。片方欠けでconnect内throw
    // （無音死）にならないよう4ターゲットすべての存在を確認する
    if (!this.hasCardListTarget || !this.hasNextButtonTarget || !this.hasPrevButtonTarget || !this.hasPaginationTarget) {
      // カードが複数あるのに矢印・ドットが欠けているのはslim側の不整合。
      // .swiperWrapper が自前で display: flex を持つため見た目は「1枚目しか見えない」
      // （2枚目以降が .qa-wrapper の overflow: hidden でクリップされる）状態になり、
      // JSエラーも出ず気づけないため警告を残す
      if (this.hasCardListTarget && this.cardListTarget.querySelectorAll('.swiper-slide').length > 1) {
        console.warn('staff_qa: カードが複数あるがカルーセルのターゲットが欠けているため初期化をスキップしました')
      }
      return
    }

    const swiper = new Swiper(this.cardListTarget, {
      slidesPerView: 1,
      spaceBetween: 44,
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
      },
      pagination: {
        el: this.paginationTarget,
        clickable: true,
        bulletActiveClass: `${this.className}::active`,
      },
    })

    swiper.enable()
  }
}
